import { useQuery } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';

const { CONTROLLERS: { APP_CENTER: { BASE } } } = USER;

export const useVendorData = (customerId: string, vendorId: number) => useQuery(
  [`vendorData${vendorId}`],
  async () => {
    const { data } = await httpService.get((`${BASE_URL}/api/v2/user/${customerId}/${BASE}/vendor/${vendorId}`));
    return data;
  },
  {
    onError: (err: any) => {
      console.log(err);
    },
    enabled: false,
  },
);
